export function normalizeKlineTheme(theme) {
    return theme === 'light' ? 'light' : 'dark';
}

export function applyKlineProTheme(chart, theme, container) {
    const normalizedTheme = normalizeKlineTheme(theme);

    if (container) {
        container.setAttribute('data-theme', normalizedTheme);
    }

    if (chart && typeof chart.setStyles === 'function') {
        chart.setStyles(normalizedTheme);
    }

    return normalizedTheme;
}
